// /components/NotificationDropdown.jsx
import React, { useEffect, useState, useRef } from "react";
import notificationsData from "./data/notification.json";
import { timeAgo } from "../../UI-comp/timeAGo";
import "./NotificationDropdown.css";

const NotificationDropdown = ({ onClose }) => {
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setNotifications(notificationsData); // simulate fetch
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const markAsRead = (id) => {
    setNotifications(prev =>
      prev.map(n => (n.id === id ? { ...n, read: true } : n))
    );
  };

  return (
    <div className="nb-notification-dropdown" ref={dropdownRef}>
      <h4 style={{fontSize: 35}}>Notifications</h4>
      {notifications.length === 0 ? (
        <p className="empty">No notifications</p>
      ) : (
        notifications.map((notif) => (
          <div
            key={notif.id}
            className={`notif-item ${notif.read ? "" : "unread"}`}
            onClick={() => markAsRead(notif.id)}
          >
            <span className="notif-msg">
              <strong>{notif.fromUser}</strong> {notif.action}
            </span>
            <span className="notif-time">{timeAgo(notif.timestamp)}</span>
          </div>
        ))
      )}
    </div>
  );
};

export default NotificationDropdown;
